angular
    .module('annexaApp')
    .component('annexaBoxThirds',{
        templateUrl: './components/thirds/annexa-box-thirds/annexa-box-thirds.html',
        controller:['globalModals', 'Language', 'AnnexaEntityFactory', 'ModalService', '$rootScope', 'AnnexaObjectBoxFactory', 'AnnexaFormlyFactory', 'GlobalDataFactory', '$filter', '$scope', 'RegFactory', 'ThirdFactory', function(globalModals, Language, AnnexaEntityFactory, ModalService, $rootScope, AnnexaObjectBoxFactory, AnnexaFormlyFactory, GlobalDataFactory, $filter, $scope, RegFactory, ThirdFactory) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            vm.showLongAddressLanguage = $rootScope.app.configuration.show_long_address_language && $rootScope.app.configuration.show_long_address_language.value;

            $scope.$on('annexaAdvancedSearchModalAdd', function (event, args) {
                if(args.id == 'modalASThirds') {
                    _.forEach(args.selected, function (item) {
                        vm.search.searchedValue = { id: item.id, object: item };
                        vm.search.searchAdd();
                    });

                    args.modal.close();
                } else if(args.id == 'modalASExternalThirds') {
                    _.forEach(args.selected, function (item) {
                    	if (item && item.identificationReferences) {
                    		ThirdFactory.getPersonByDboid(item.identificationReferences[0].identificationReference).then(function (data) {
                    			vm.new.newFunction(JSOG.decode(data[0]));
                    		}).catch(function (data) {
                    			//Empty
                    		});
                    	} else {
                    		vm.new.newFunction(item);
                    	}
                    });

                    args.modal.close();
                }
            });

            this.$onInit = function () {
            	
                vm.thirdModule = $linq(GlobalDataFactory.modules).where("x => x.url == 'annexa.thirds'").toArray();

                if(!vm.boxTitle) {
                    vm.boxTitle = 'global.literals.receivers';
                }

                if(!vm.search) {
                    vm.search = {};
                }

                if(!vm.search.addedSelect){
                	vm.search.addedSelect = 'NoSelect';
                }
                vm.search.origin = 'thirds';
                vm.search.type = 'Third';
                vm.search.processSearch = function(object) {
                    if(object.corporateName) {
                        return object.corporateName + ' (' + object.identificationDocument + ')';
                    } else {
                        return object.name + (object.surname1Particles ? ' ' + object.surname1Particles : '') + ' ' + object.surename1 + (object.surname2Particles ? ' ' + object.surname2Particles : '') + (object.surename2 ? ' ' + object.surename2 : '') + ' (' + object.identificationDocument + ')';
                    }
                }
                if(!vm.search.annexaFormModalOnAdd && !vm.search.noAddmodalOnAdd) {

        			var roles = [];
        			
        			if(vm.entryType == 'INPUT') {
        				roles = $linq(GlobalDataFactory.roleInteresteds).where("x => x.canUseRegisterEntry").toArray();
                    } else if(vm.entryType == 'OUTPUT') {
                    	roles = $linq(GlobalDataFactory.roleInteresteds).where("x => x.canUseRegisterOutput").toArray();
                    }
                	
                    var getRepresentateds = function() {
                        var retRepresentateds = [];

                        var representeds = $linq(vm.content).where("x => x.representated != null").select("x => x.representated").toArray();

                        var interested = [];
                        if(vm.search && vm.search.searchedValue && vm.search.searchedValue.id) {
                        	interested = $linq(vm.content).where("x => x.interested && x.third.id != " + vm.search.searchedValue.id).except(representeds,"(x,y) => x.id == y.third.id").toArray();
                        } else {
                        	interested = $linq(vm.content).where("x => x.interested").except(representeds,"(x,y) => x.id == y.third.id").toArray();
                        }

                        _.forEach(interested, function (value) {
                            var representated = value.third;
                            if(value.third.name) {
                                representated.label = value.third.name + ((value.third.surname1Particles)? ' ' + value.third.surname1Particles : '') + ' ' + value.third.surename1 + ((value.third.surname2Particles)? ' ' + value.third.surname2Particles : '') + ((value.third.surename2)? ' ' + value.third.surename2 : '') + ' (' + value.third.identificationDocument + ')';
                            }else{
                                representated.label = value.third.corporateName + ' (' + value.third.identificationDocument + ')';
                            }
                            retRepresentateds.push(representated);
                        });

                        return retRepresentateds
                    }
                    
                    var addressesArray = function() {
                        var content = [];

                        if(vm && 
                        		vm.search && 
                        		vm.search.searchedValue && 
                        		vm.search.searchedValue.object &&
                        		vm.search.searchedValue.object.addresses) {
                        	var lstAddresses = vm.search.searchedValue.object.addresses;
                        	var thirdAddress = new ThirdAddress(vm.search.searchedValue.object, vm.languageColumn, undefined, vm.showLongAddressLanguage);
                        	
                        	if (lstAddresses && lstAddresses.length > 0) {
                        		var notificationTypes = angular.copy(GlobalDataFactory.notificationTypes);
								notificationTypes = ((notificationTypes)?$linq(notificationTypes).select("x => x.addressType").distinct().toArray():[]);
		                    	var addressWithConsentOrDefault = ThirdFactory.getThirdAddresByThirdWithConsent(vm.search.searchedValue.object, ((vm.config)?vm.config.dossier:undefined), ((vm.config)?vm.config.viewConsentAll:false))
                            	_.forEach(lstAddresses, function (value) {
									if(_.contains(notificationTypes, value.addressType)){
			                    		var thirdAddressId = value.id;
	                            		var addressHtml = thirdAddress.getAddressHtml(value, false, true);
	                            		var active = false;
	                            		var activeType = '';
	                            		if(addressWithConsentOrDefault && addressWithConsentOrDefault.address && addressWithConsentOrDefault.address.id && value.id && value.id == addressWithConsentOrDefault.address.id){
	                            			active = true;
	                            			if(addressWithConsentOrDefault.isDefault){
	                            				activeType = $filter('translate')('global.literals.defaultValue');
	                            			}else{
	                            				activeType = $filter('translate')('global.literals.withConsentAddress');
	                            			}
	                            		}
	                            		var address = {value: thirdAddressId, label: addressHtml, active:active, activeType: activeType};  
	                            		content.push(address);
									}
                            	})
                        	}
                        	
                        }

                        return content;
                    }

                    vm.search.annexaFormModalOnAdd = {
                        title: 'global.literals.receiver',
                        size: '',
                        fieldsDefinition: [
                        	{ type: 'field', id: 'thirdType', fieldType: 'radio_checkbox', isRadio: true, 
                        		data: [],  
                        		colClass: 'col-sm-12', required: true, label: 'global.literals.type' , labelProp: 'label',
                        		controller: ['$scope', function($scope) {
                        			var exist = false;
                        			_.forEach(vm.content, function (value) {
                        				if(value.interested && value.third.id == vm.search.searchedValue.id) {
                        					exist = true;
                        				}
                        			});
                        			if(exist) {
                        				$scope.to.options = [{value: 'representative', label: $filter('translate')('global.literals.representative')}];
                        			} else {
                        				$scope.to.options = [{value: 'interested', label: $filter('translate')('global.literals.interested')},
        													{value: 'representative', label: $filter('translate')('global.literals.representative')}];
                        			}
                                }]
                        	},
                        	{ type: 'field', id: 'roleInterested', fieldType: 'select', data: [], required: false, label: 'global.literals.roleInterested', labelProp: 'label',
                        		hideExpression: function($viewValue, $modelValue, scope) {
                        			var hide = true;
                                	if (scope.model.thirdType == 'interested' && roles) {
                                		hide = false;
                                	}
                                	return hide;
                        		},	
                        		controller: ['$scope', function($scope) { 
                        			$scope.to.labelProp = vm.languageColumn;
                                	$scope.to.options = $linq(roles).orderBy("x => x." + vm.languageColumn, linq.caseInsensitiveComparer).toArray();
                                }]
                        	},	
                            { type: 'field', id: 'representated', fieldType: 'select', data: getRepresentateds(), required: false, label: 'global.literals.representated', labelProp: 'label',
                                hideExpression: function($viewValue, $modelValue, scope) { return scope.model.thirdType != 'representative'; },
                                controller: ['$scope', function($scope) { 
                                	$scope.to.options = getRepresentateds() 
                                }]
                            },
                            { type: 'field', id: 'thirdAddress', fieldType: 'radio_html_circle', isRadio: true, data: addressesArray(), colClass: 'col-sm-12', required: false, label: 'global.literals.notificationChannel' , labelProp: 'label',
                                controller: ['$scope', function($scope) { 
                                	$scope.to.options = addressesArray() 
                                }]
                            }
                        ],
                        alerts: []
                    }
                }

                if(!vm.search.modalOnAddProcessModel) {
                    vm.search.modalOnAddProcessModel = function(selected) {
                        return { third: selected.id, interested: false, representative: false, object: selected.object };
                    }
                }
                if(!vm.search.completeAdd) {
                    vm.search.completeAdd = function() {
                    	//Carga los datos en html de la direccion seleccionada
                    	var addressHtml;
                    	var thirdAddressId;
                    	if (this.model && this.model.thirdAddress) {
                    		thirdAddressId = this.model.thirdAddress
	                    	var lstAddresses = vm.search.searchedValue.object.addresses;
	                    	var thirdAllAddress = new ThirdAddress(vm.search.searchedValue.object, vm.languageColumn, undefined, vm.showLongAddressLanguage);
	                    	if (lstAddresses && thirdAddressId) {
	                    		var value = $linq(lstAddresses).where("x => x.id == '"+ thirdAddressId +"'").toArray();
	                    		addressHtml = thirdAllAddress.getAddressHtml(value[0], true, false);
	                    	}
                    	}
                    	
                        var newContent = {
                            third: vm.search.searchedValue.object,
                            interested: this.model.thirdType == 'interested' ? true : false,
                            roleInterested: this.model.roleInterested ? $linq(GlobalDataFactory.roleInteresteds).where("x => x.id == " + this.model.roleInterested).toArray()[0] : undefined,
                            representative: this.model.thirdType == 'representative' ? true : false,
                            principal: vm.content.length == 0 ? true : false,
                            addresses: new BoxThird(vm.search.searchedValue.object, vm.languageColumn, vm.showLongAddressLanguage).getAdressesHtml(),
                            representated: this.model.representated ? $linq(vm.content).where("x => x.third && x.third.id == '"+ this.model.representated +"'").toArray()[0].third : undefined,
                            thirdAddress: thirdAddressId,
                            thirdAddressHtml: addressHtml
                        }

                        if (this.model.thirdType == 'interested' || (this.model.thirdType == 'representative' && this.model.representated) ) {
	
	                        vm.search.searchedValue = { id: -1, value: '' };
	                        if(vm.search.saveSearch) {
	                            vm.search.saveSearch(newContent);
	                        } else {
	                        	vm.content.push(newContent);
	                        }
                        
                        	$rootScope.$broadcast('closeAnnexaFormModal', { id: 'modalSearchAdd' });
                        }else if(this.model.thirdType == 'representative' && !this.model.representated){
                        	vm.search.annexaFormModalOnAdd.alerts.push({ msg: $filter('translate')('global.errors.emptyThirdRepresentated') });
                        }
                    }
                }

                vm.search.advancedSearch = function() {
                    var renderThirdType = function(data, type, full, meta) {
                        var content = '';
                        var icon = '';

                        switch (data) {
                            case 'PHISICAL':
                                icon = 'fa-user fa-lg ico-third';
                                break;
                            case 'LEGAL':
                                icon = 'fa-bank fa-lg ico-third';
                                break;
                            case 'PERSONWITHOUTLEGALPERSONALITY':
                                icon = 'fa-puzzle-piece fa-lg ico-third';
                                break;
                        }

                        content = '<i class="fa ' + icon + '"></i>';

                        return content;
                    }

                    var renderAddresses = function(data, type, full, meta) {
                        var content = '';

                        if(full) {
                            content = new ThirdAddress(full, vm.languageColumn, undefined, vm.showLongAddressLanguage).getDefaultAddressHtml();
                        }

                        return content;
                    }

                    var advancedSearchModal = {
                        title: 'global.literals.advanced_search_receivers',
                        size: 'modal-lg',
                        filter: [
                            { id: 'identificationDocument', type: 'text', order: 0, label: 'global.literals.identifier' },
                            { id: 'name', type: 'text', order: 1, label: 'global.literals.name' },
                            { id: 'identificationReference', type: 'text', order: 2, label: 'global.thirds.literals.identificationReference'},
                            { id: 'onlyActive', type: 'checkbox', order: 3, label: 'global.thirds.literals.onlyActive', callAux: true, model: true},
                            { id: 'city', type: 'text', order: 0, label: 'global.literals.city', userChoosen: true, callAux: true },
                            { id: 'mail', type: 'text', order: 1, label: 'global.profile.email', userChoosen: true, callAux: true },
                            { id: 'phone', type: 'text', order: 2, label: 'global.profile.phone', userChoosen: true, callAux: true },
                            { id: 'identificationDocumentType', type: 'select', order: 3, label: 'global.thirds.literals.identificationdocumenttype', dataType: 'LOCAL', data: GlobalDataFactory.thirdIdentificationDocumentTypes, addAll: true, nameProperty: vm.languageColumn, userChoosen: true, callAux: true },
                            { id: 'thirdType', type: 'select', order: 4, label: 'global.literals.type', dataType: 'LOCAL', data: GlobalDataFactory.thirdTypes, addAll: true, nameProperty: vm.languageColumn, userChoosen: true, callAux: true },
                            { id: 'dataThird', type: 'dateRange', order: 5, label: 'global.thirds.literals.dateCreated', userChoosen: true, callAux: true }
                        ],
                        tableDefinition: {
                            id: 'tableAdvancedSearchThirds',
                            origin: 'thirds',
                            objectType: 'Third',
                            sortName: 'identificationDocument',
                            sort: [[2, 'asc']],
                            columns: [
                                { id: 'thirdType', title: $filter('translate')('global.literals.type'), render: renderThirdType, sortable: false },
                                { id: 'identificationDocument', title: $filter('translate')('global.literals.identifier') },
                                { id: 'id', width: '25%', column: new ThirdColumn($filter, 'global.thirds.literals.datatable.col2', true) },
                                { id: 'addresses', title: $filter('translate')('global.thirds.literals.datatable.col4'), render: renderAddresses, sortable: false }
                            ],
                            noLoading: true,
                            skipFirstSearch: true,
                            callAuxToAdd: { added: [] }
                        },
                        multiple: false
                    }
                    
                    if(vm.search.addedSelect != 'NoSelect') {
                    	advancedSearchModal.tableDefinition.callAuxToAdd.added = $linq(vm.content).select(vm.search.addedSelect).toArray();
                    }

                    AnnexaFormlyFactory.showAnnexaAdvancedSearchModal('modalASThirds', advancedSearchModal);
                }

                vm.search.advancedExternalSearch = function() {
                    var renderThirdType = function(data, type, full, meta) {
                        var content = '';
                        var icon = '';

                        switch (data) {
                            case 'PHISICAL':
                                icon = 'fa-user fa-lg ico-third';
                                break;
                            case 'LEGAL':
                                icon = 'fa-bank fa-lg ico-third';
                                break;
                            case 'PERSONWITHOUTLEGALPERSONALITY':
                                icon = 'fa-puzzle-piece fa-lg ico-third';
                                break;
                        }

                        content = '<i class="fa ' + icon + '"></i>';

                        return content;
                    }

                    var renderAddresses = function(data, type, full, meta) {
                        var content = '';

                        if(full) {
                            content = new ThirdAddress(full, vm.languageColumn, undefined, vm.showLongAddressLanguage).getDefaultAddressHtml();
                        }

                        return content;
                    }

                    var advancedSearchModal = {
                        title: (($rootScope.app.configuration.conectaNucli_config && $rootScope.app.configuration.conectaNucli_config.title_external_search) ? $rootScope.app.configuration.conectaNucli_config.title_external_search : 'global.literals.advanced_external_search'),
                        size: 'modal-lg',
                        filter: [
                            { id: 'identificationDocument', type: 'text', order: 0, label: 'global.literals.identifier' },
                            { id: 'completeName', type: 'text', order: 1, label: 'global.literals.name' },
                            { id: 'identificationReference', type: 'text', order: 2, label: 'global.thirds.literals.identificationReference'}
                        ],
                        tableDefinition: {
                            id: 'tableAdvancedSearchThirds',
                            origin: 'thirds',
                            objectType: 'Third',
                            sortName: 'identificationDocument',
                            sort: [[2, 'asc']],
                            columns: [
                                { id: 'thirdType', title: $filter('translate')('global.literals.type'), render: renderThirdType, sortable: false },
                                { id: 'identificationDocument', title: $filter('translate')('global.literals.identifier') },
                                { id: 'id', width: '25%', column: new ThirdColumn($filter, 'global.thirds.literals.datatable.col2', true) },
                                { id: 'addresses', title: $filter('translate')('global.thirds.literals.defaultAddress'), render: renderAddresses, sortable: false }
                            ],
                            noLoading: true,
                            skipFirstSearch: true,
                            callAuxToAdd: { externalSearch:true, added: [] }
                        },
                        multiple: false
                    }

                    if(vm.search.addedSelect != 'NoSelect') {
                    	advancedSearchModal.tableDefinition.callAuxToAdd.added = $linq(vm.content).select(vm.search.addedSelect).toArray();
                    }
                    
                    AnnexaFormlyFactory.showAnnexaAdvancedSearchModal('modalASExternalThirds', advancedSearchModal);
                }
                
                if(!vm.new) {
                    vm.new = {};
                }

                vm.new.newFunction = function(model) {
                    var modal = angular.copy(globalModals.receiverNew);

                    if(vm.entryType == 'INPUT') {
                        modal.title = 'global.literals.newRemitent';
                    } else if(vm.entryType == 'OUTPUT') {
                        modal.title = 'global.literals.new_receiver_modal_title';
                    }

                    //region Això s'haurà de canviar quan arreglem tercers

                    var proccesNew = function(item, form) {
                        vm.search.searchedValue = { id: item.third.id, object: item.third }
                        $rootScope.$broadcast('annexaObjectBoxSearchAdd');
                        form.close();
                    }

                    if (model) {
                    	modal.annexaFormly.model = model;
                    }

                    var entity = new AnnexaEntity(new Date().getTime() + '', 'modal', AnnexaEntityFactory.getThirdBoxNewForm(modal, proccesNew), AnnexaEntityFactory.getThirdBoxes());

                    if (model) {
                    	if (model.identificationReferences) {
                        	var modelIR = [];
    						_.forEach(model.identificationReferences, function(val) {
    							var identificationReference = { identificationReference: val.identificationReference, identificationReferenceType: val.identificationReferenceType }
    							modelIR.push(identificationReference);
    						});
                        	entity.boxes[0].boxDefinition.content = modelIR;
                    	}
                        if (model.addresses) {
                        	entity.boxes[1].boxDefinition.content = model.addresses;
                        }
                    }

                    modal.annexaFormly = entity.form;
                    modal.boxes = entity.boxes;
                    modal.submitModal = modal.annexaFormly.onSubmit;
                    modal.alerts = [];
                    entity.modal = modal;

                    ModalService.showModal({
                        template: '<annexa-entity id="' + entity.id + '" entity-definition="modalObj" class="modal black-overlay" data-backdrop="false"/>',
                        controller: 'AnnexaFormlyModalController',
                        modalObj: entity
                    }).then(function(modalThen) {
                        modal.modal = modalThen;
                        modal.close = modalThen.element.scope().close;
                        modal.annexaFormly.close = modalThen.element.scope().close;
                        modalThen.element.modal();
                        angular.element(".modal-title").focus();
                    });

                    //endregion
                }
                
				if ($rootScope.app.configuration.conectaNucli_config && $rootScope.app.configuration.conectaNucli_config.active) {
					vm.new.newFunc = vm.search.advancedExternalSearch;
				} else {
					vm.new.newFunc = vm.new.newFunction;
				}

                if(vm.isEdit) {
                    _.forEach(vm.content, function(item, index) {
                    	if (item.thirdAddress) {
                    		var thirdAllAddress = new ThirdAddress(item.third, vm.languageColumn, undefined, vm.showLongAddressLanguage);
                    		vm.content[index].thirdAddressHtml = thirdAllAddress.getAddressHtml(item.thirdAddress, true, false);
                    	}
                        if(item.third && item.third.addresses) {
                            vm.content[index].addresses = new BoxThird(item.third, vm.languageColumn, vm.showLongAddressLanguage).getAdressesHtml()
                        }
                    })
                }
            }
        }],
        bindings: {
            boxTitle: '@?',
            permissions: '=',
            search: '=',
            new: '=',
            content: '=',
            emptyText: '@',
            isEdit: '=',
            entryType: '@?',
            config: '=',
            origin: '@'
        }
    })
    .component('annexaBoxThirdsRender', {
        templateUrl: './components/thirds/annexa-box-thirds/annexa-box-thirds-render.html',
        require: {
            objectBoxComponent: '^^annexaObjectBox',
        },
        controller:['RegFactory', '$filter', 'DialogsFactory', '$rootScope', '$q', '$scope', 'AnnexaFormlyFactory', 'globalModals', 'Language', '$http', 'ErrorFactory', 'GlobalDataFactory', function(RegFactory, $filter, DialogsFactory, $rootScope, $q, $scope, AnnexaFormlyFactory, globalModals, Language, $http, ErrorFactory, GlobalDataFactory) {
            var vm = this;
            
            vm.languageColumn = Language.getActiveColumn();
            vm.showLongAddressLanguage = $rootScope.app.configuration.show_long_address_language && $rootScope.app.configuration.show_long_address_language.value;

            vm.setPrincipal = function (index) {
                if(vm.content.length > 0) {
                    _.forEach(vm.content, function(item, cont) {
                        vm.content[cont].principal = false;
                    });

                    vm.content[index].principal = true;

                    if(vm.isEdit) {
                        $rootScope.$broadcast('annexaBoxThirdsSetPrincipal', { id: vm.content[index].id, origin: vm.origin});
                    }
                }
            }

            vm.getShowName = function (third) {
                if(third.thirdType != 'PHISICAL') {
                    return third.corporateName;
                } else {
                    return third.name + (third.surname1Particles ? ' ' + third.surname1Particles : '') + ' ' + third.surename1 + (third.surname2Particles ? ' ' + third.surname2Particles : '') + (third.surename2 ? ' ' + third.surename2 : '');
                }
            }

            vm.getRepresentativeText = function(item) {
                if(item.representative && item.representated) {
                    var representated = undefined;

                    if(item.representated.hasOwnProperty('id')) {
                        representated = item.representated;
                    } else {
                    	var third = $linq(vm.content).firstOrDefault(undefined, "x => x.third.id == " + item.representated);
                        representated = third.third;
                    }

                    return $filter('translate')('global.literals.representative',{ representated: vm.getShowName(representated) + ' (' + representated.identificationDocument + ')' });
                } else if (item.representative){
                    return $filter('translate')('global.literals.representative');
                } else{
                	return '';
                }
            }

            vm.delete = function(index) {
                DialogsFactory.confirm('global.literals.delete', 'global.literals.deleteThirdBox')
                    .then(function (data) {
                        var removedIds = [];

                        var removed = angular.copy(vm.content[index]);
                        vm.content.splice(index, 1);
                        removedIds.push(removed.id);

                        if(removed.interested){
                            var indexRepresentative = $linq(vm.content).indexOf("x => x.representative && x.representated && (x.representated == " + removed.third.id + " || x.representated.id == " + removed.third.id + ")");

                            if(indexRepresentative != -1) {
                                removedIds.push(vm.content[indexRepresentative].id);
                                vm.content.splice(indexRepresentative, 1);
                            }
                        }

                        if(vm.isEdit) {
                            $rootScope.$broadcast('annexaBoxThirdsDelete', { removedIds: removedIds, origin: vm.origin});
                        }
                    }).catch(function (data) {
                        //Empty
                });
            }

            vm.showAddresses = function() {
                return vm.origin != 'annexa-box-object-reg' || (vm.origin == 'annexa-box-object-reg' && vm.entryType != 'INPUT')
            }
            
            vm.editThirdReceiver = function(index) {  
            	var receiver = angular.copy(vm.content[index]);
            	$scope.receiver = receiver;
            	$scope.index = index;  
            	
            	var roles = [];
    			
    			if(vm.entryType == 'INPUT') {
    				roles = $linq(GlobalDataFactory.roleInteresteds).where("x => x.canUseRegisterEntry").toArray();
                } else if(vm.entryType == 'OUTPUT') {
                	roles = $linq(GlobalDataFactory.roleInteresteds).where("x => x.canUseRegisterOutput").toArray();
                }
            	
            	if (receiver.interested) {
            		var receiverThirdType = 'interested';
	        	} else if (receiver.representative) {
	        		var receiverThirdType = 'representative';
	        	}
            	if (receiver.representated) {
            		if (typeof receiver.representated == 'number') {
            			var idReceiverRepresentated = receiver.representated;
            		} else {
            			var idReceiverRepresentated = receiver.representated.id;
            		}
            	}
            	if (receiver.thirdAddress) {
            		if (typeof receiver.thirdAddress == 'number') {
            			var idReceiverThirdAddress = receiver.thirdAddress;
            		} else {
            			var idReceiverThirdAddress = receiver.thirdAddress.id;
            		}
            	}
            	
            	var getRepresentateds = function(receiver) {
                    var retRepresentateds = [];

                    if (idReceiverRepresentated) {
                    	var representeds = $linq(vm.content).where("x => x.representated != null && ((x.representated.id != " + idReceiverRepresentated + ") && (x.representated != " + idReceiverRepresentated + "))").select("x => x.representated").toArray();
                    } else {
                    	var representeds = $linq(vm.content).where("x => x.representated != null").select("x => x.representated").toArray();
                    }
                    
                    var interested = $linq(vm.content).where("x => x.interested && x.third.id != " + receiver.third.id).except(representeds,"(x,y) => (x.id && (x.id == y.third.id)) || (x == y.third.id)").toArray();
                    
                    _.forEach(interested, function (value) {
                        var representated = value.third;
                        if(value.third.name) {
                            representated.label = value.third.name + ((value.third.surname1Particles)? ' ' + value.third.surname1Particles : '') + ' ' + value.third.surename1 + ((value.third.surname2Particles)? ' ' + value.third.surname2Particles : '') + ((value.third.surename2)? ' ' + value.third.surename2 : '') + ' (' + value.third.identificationDocument + ')';
                        }else{
                            representated.label = value.third.corporateName + ' (' + value.third.identificationDocument + ')';
                        }
                        retRepresentateds.push(representated);
                    });

                    return retRepresentateds
                }
            	
            	var addressesArray = function(receiver) {
                    var content = [];

                    if(receiver) {
                    	var lstAddresses = receiver.third.addresses;
                    	var thirdAddress = new ThirdAddress(receiver, vm.languageColumn, undefined, vm.showLongAddressLanguage);
                    	
                    	if (lstAddresses && lstAddresses.length > 0) {
							var notificationTypes = angular.copy(GlobalDataFactory.notificationTypes);
							notificationTypes = ((notificationTypes)?$linq(notificationTypes).select("x => x.addressType").distinct().toArray():[]);
							_.forEach(lstAddresses, function (value) {
								if(_.contains(notificationTypes, value.addressType)){
	                        		var thirdAddressId = value.id;
	                        		var addressHtml = thirdAddress.getAddressHtml(value, false, true);
	                        		var address = {value: thirdAddressId, label: addressHtml};  
	                        		content.push(address);
								}
	                        });
                    	}
                    	
                    }

                    return content;
                }
            	
            	var getIdReceiverOptionRoleInterested = function(receiver) {
            		if (receiver.roleInterested) {
            			return receiver.roleInterested.id;
            		}
            		return undefined;
            	}
            	
            	var modalEditReceiver = {
                    title: 'global.literals.edit_receiver',
                    size: '',
                    fieldsDefinition: [
                    	{ type: 'field', id: 'thirdType', fieldType: 'radio_checkbox', isRadio: true, 
                    		data: [{value: 'interested', label: $filter('translate')('global.literals.interested')},
                    			   {value: 'representative', label: $filter('translate')('global.literals.representative')}],
                       		controller: ['$scope', function($scope) { 
                       			var exist = false;
                       			if(!receiver.interested) {
                       				_.forEach(vm.content, function (value) {
                                        if(value.interested && value.third.id == receiver.third.id) {
                                            exist = true;
                                        }
                                    });
                       			}
                                if(exist) {
                                	$scope.model.thirdType = 'representative';
                                    $scope.to.options = [{value: 'representative', label: $filter('translate')('global.literals.representative')}];
                                } else {
                                	$scope.to.options = [
                                		{value: 'interested', label: $filter('translate')('global.literals.interested')},
                         			    {value: 'representative', label: $filter('translate')('global.literals.representative')}
                                    ];
                                }
                            }],
                    		defaultValue: receiverThirdType,
                    		colClass: 'col-sm-12', required: true, label: 'global.literals.type' , labelProp: 'label'},
                		{ type: 'field', id: 'roleInterested', fieldType: 'select', data: GlobalDataFactory.roleInteresteds, required: false, label: 'global.literals.roleInterested', labelProp: 'label',
                    		defaultValue: getIdReceiverOptionRoleInterested(receiver),
                    		hideExpression: function($viewValue, $modelValue, scope) {
                    			var hide = true;
                            	if (scope.model.thirdType == 'interested' && GlobalDataFactory.roleInteresteds) {
                            		hide = false;
                            	}
                            	return hide;
                    		},	
                    		controller: ['$scope', function($scope) { 
                    			$scope.to.labelProp = vm.languageColumn;
                            	$scope.to.options = $linq(roles).orderBy("x => x." + vm.languageColumn, linq.caseInsensitiveComparer).toArray();
                            }]
                    	},	
                        { type: 'field', id: 'representated', fieldType: 'select', data: getRepresentateds(receiver), required: false, label: 'global.literals.representated', labelProp: 'label',
                    		defaultValue: idReceiverRepresentated,	
                            hideExpression: function($viewValue, $modelValue, scope) { return scope.model.thirdType != 'representative'; },
                            controller: ['$scope', function($scope) { 
                            	$scope.to.options = getRepresentateds(receiver) 
                            }]
                        },
                        { type: 'field', id: 'thirdAddress', fieldType: 'radio_checkbox', isRadio: true, data: addressesArray(receiver), colClass: 'col-sm-12', required: false, label: 'global.literals.notificationChannel' , labelProp: 'label',
                        	defaultValue: idReceiverThirdAddress,
                            controller: ['$scope', function($scope) { 
                            	$scope.to.options = addressesArray(receiver)
                            }]
                        }
                    ],
                    alerts: []
                }     
            	
            	var submitFunction = function() {
                	var receiver = $scope.receiver; 
                	var thirdType = this.model.thirdType;
                	var idRepresentated = this.model.representated;
                	var idThirdAddress = this.model.thirdAddress;
                	var idRoleInterested = this.model.roleInterested;
                	if(thirdType == 'representative' && idRepresentated == undefined){
                		modalEditReceiver.alerts.push({ msg: $filter('translate')('global.errors.emptyThirdRepresentated') });
                	}else{
	                	if (receiver.id && !receiver.idDossier) {
	                		//Se guarda en BBDD
		                	return $http({
		                        url: './api/register_entry_third/' + receiver.id,
		                        method: 'GET'
		                    }).then(function (data) {
		                        var registerEntryThird = JSOG.decode(data.data);
		                        
		                        if (thirdType == 'interested') {
		                        	registerEntryThird.interested = true;
		                        	registerEntryThird.representated = undefined;
		                        	if (registerEntryThird.roleInterested) {
		                        		registerEntryThird.roleInterested.id = idRoleInterested ? idRoleInterested : undefined;
		                        	} else {
		                        		registerEntryThird.roleInterested = idRoleInterested ? {id: idRoleInterested} : undefined;
		                        	}
		                        } else {
		                        	registerEntryThird.interested = false;
		                        	registerEntryThird.roleInterested = undefined;
		                        }
		                        
		                        if (thirdType == 'representative') {
		                        	registerEntryThird.representative = true;
		                        	if (registerEntryThird.representated) {
		                            	registerEntryThird.representated.id = idRepresentated ? idRepresentated : undefined;
		                            } else {
		                            	registerEntryThird.representated = idRepresentated ? {id: idRepresentated} : undefined;
		                            }
		                        } else {
		                        	registerEntryThird.representative = false;
		                        }  
		                        
		                        if (idThirdAddress) {
		                        	if (!registerEntryThird.thirdAddress || (registerEntryThird.thirdAddress && registerEntryThird.thirdAddress.id != idThirdAddress)) {
		                        		var thirdAddress = $linq(registerEntryThird.third.addresses).where("x => x.id == '"+ idThirdAddress +"'").toArray();
		                        		registerEntryThird.thirdAddress = thirdAddress[0];
		                        	}
		                        } else {
		                        	registerEntryThird.thirdAddress = undefined;
		                        }
		                        
		                        RegFactory.updateRegisterEntryThird(receiver.id, registerEntryThird)
		                            .then(function(data) {
		                            	if (data.roleInterested) {
		                            		data.roleInterested = $linq(GlobalDataFactory.roleInteresteds).where("x => x.id == " + data.roleInterested.id).toArray()[0] 
		                            	}
		                            	
		                            	if (data.thirdAddress) {
		                            		var thirdAllAddress = new ThirdAddress(data.third, vm.languageColumn, undefined, vm.showLongAddressLanguage);
		                            		var addressHtml = thirdAllAddress.getAddressHtml(data.thirdAddress, true, false);
		                            	}
		                            	
		                            	var receiver = data;
		                            	if (addressHtml) {
		                            		receiver.thirdAddressHtml = addressHtml;
		                            	}
		                            	data.addresses = new BoxThird(data.third, vm.languageColumn, vm.showLongAddressLanguage).getAdressesHtml();
		                            	
		                            	vm.content[$scope.index] = data;
		                            	
		                            	$rootScope.$broadcast('closeAnnexaFormModal', { id: 'modalSearchAdd' });
		                            }).catch(function (error) {
		                                console.error(error);
		                                modalEditReceiver.alerts.push({ msg: ErrorFactory.getErrorMessage('registerEntryThird', 'update', error) });
		                        });
		                        
		                    }).catch(function (error) {
		                        console.error(error);
		                        modalEditReceiver.alerts.push({ msg: ErrorFactory.getErrorMessage('registerEntryThird', 'update', error) });
		                    });   
	                	} else {
	                		//No se guarda en BBDD
	                		if (thirdType == 'interested') {
	                			receiver.interested = true;
	                			receiver.representated = undefined;
	                			receiver.roleInterested = idRoleInterested ? $linq(GlobalDataFactory.roleInteresteds).where("x => x.id == " + idRoleInterested).toArray()[0] : undefined;
	                        } else {
	                        	receiver.interested = false;
	                        	receiver.roleInterested = undefined;
	                        }
	                        
	                        if (thirdType == 'representative') {
	                        	receiver.representative = true;
	                        	receiver.representated = idRepresentated ? idRepresentated : undefined;
	                        } else {
	                        	receiver.representative = false;
	                        }  
	                        
	                        if (idThirdAddress) {
	                        	if (!receiver.thirdAddress || (receiver.thirdAddress && receiver.thirdAddress.id != idThirdAddress)) {
	                        		var thirdAddress = $linq(receiver.third.addresses).where("x => x.id == '"+ idThirdAddress +"'").toArray();
	                        		receiver.thirdAddress = thirdAddress[0];
	                        	}
	                        } else {
	                        	receiver.thirdAddress = undefined;
	                        }
	                        
	                        if (receiver.thirdAddress) {
	                    		var thirdAllAddress = new ThirdAddress(receiver.third, vm.languageColumn, undefined, vm.showLongAddressLanguage);
	                    		var addressHtml = thirdAllAddress.getAddressHtml(receiver.thirdAddress, true, false);
	                    	}
	                    	if(additionalInformation){
	                    		receiver.additionalInformation = additionalInformation;
	                    	}else{
	                    		receiver.additonalInformation = undefined;
	                    	}
	                    	if (addressHtml) {
	                    		receiver.thirdAddressHtml = addressHtml;
	                    		receiver.thirdAddress = receiver.thirdAddress.id;
	                    	}
	                    	receiver.addresses = new BoxThird(receiver.third, vm.languageColumn, vm.showLongAddressLanguage).getAdressesHtml();
	                        
	                        vm.content[$scope.index] = receiver;
	                    	
	                    	$rootScope.$broadcast('closeAnnexaFormModal', { id: 'modalSearchAdd' });
	                	}
                	}
                }
                        	
            	AnnexaFormlyFactory.showAnnexaFormModal('modalSearchAdd', modalEditReceiver, submitFunction);
            }
            
        }],
        bindings: {
            content: '=',
            emptyText: '@',
            isEdit: '=',
            entryType: '@?',
            origin: '@'
        }
    })
    .component('annexaBoxThirdsRenderThird', {
        templateUrl: './components/thirds/annexa-box-thirds/annexa-box-thirds-render-third.html',
        require: {
            objectBoxComponent: '^^annexaObjectBox',
        },
        controller:['RegFactory', '$filter', 'DialogsFactory', '$rootScope', '$q', '$scope', 'AnnexaFormlyFactory', 'globalModals', 'Language', '$http', 'ErrorFactory', 'GlobalDataFactory', function(RegFactory, $filter, DialogsFactory, $rootScope, $q, $scope, AnnexaFormlyFactory, globalModals, Language, $http, ErrorFactory, GlobalDataFactory) {
            var vm = this;
            
            vm.languageColumn = Language.getActiveColumn();

            vm.delete = function(index) {
                DialogsFactory.confirm('global.literals.delete', 'global.literals.deleteThirdBox')
                    .then(function (data) {
                        var removed = angular.copy(vm.content[index]);
                        $rootScope.$broadcast('annexaBoxThirdsDelete', { removedId: removed.id, origin: vm.origin});
                    }).catch(function (data) {
                        //Empty
                });
            }
        }],
        bindings: {
            content: '=',
            emptyText: '@',
            isEdit: '=',
            entryType: '@?',
            origin: '@'
        }
    })